module.exports={
	"Form": "AssetClassificationViewManifest",
	"Scope": "AssetClassification-View",
	"Descriptors":
	{
		"AssetClassificationDetails.Name":
		{
			"Name": "Name",
			"Hash": "AssetClassification-View-Name",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 6,
				"Section": "AssetClassification-View-Identity",
				"Group": "AssetClassification-View-Identity"
			}
		},
		"AssetClassificationDetails.Description":
		{
			"Name": "Description",
			"Hash": "AssetClassification-View-Description",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "2",
				"Width": 12,
				"Section": "AssetClassification-View-Details",
				"Group": "AssetClassification-View-Details"
			}
		},
		"AssetClassificationDetails.IDAssetClassification":
		{
			"Name": "IDAsset Classification",
			"Hash": "AssetClassification-View-IDAssetClassification",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "3",
				"Width": 4,
				"Section": "AssetClassification-View-DataAudit",
				"Group": "AssetClassification-View-DataAudit"
			}
		},
		"AssetClassificationDetails.GUIDAssetClassification":
		{
			"Name": "GUIDAsset Classification",
			"Hash": "AssetClassification-View-GUIDAssetClassification",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "3",
				"Width": 4,
				"Section": "AssetClassification-View-DataAudit",
				"Group": "AssetClassification-View-DataAudit"
			}
		},
		"AssetClassificationDetails.CreateDate":
		{
			"Name": "Create Date",
			"Hash": "AssetClassification-View-CreateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "3",
				"Width": 4,
				"Section": "AssetClassification-View-DataAudit",
				"Group": "AssetClassification-View-DataAudit"
			}
		},
		"AssetClassificationDetails.CreatingIDUser":
		{
			"Name": "Creating IDUser",
			"Hash": "AssetClassification-View-CreatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 4,
				"Section": "AssetClassification-View-DataAudit",
				"Group": "AssetClassification-View-DataAudit"
			}
		},
		"AssetClassificationDetails.UpdateDate":
		{
			"Name": "Update Date",
			"Hash": "AssetClassification-View-UpdateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 4,
				"Section": "AssetClassification-View-DataAudit",
				"Group": "AssetClassification-View-DataAudit"
			}
		},
		"AssetClassificationDetails.UpdatingIDUser":
		{
			"Name": "Updating IDUser",
			"Hash": "AssetClassification-View-UpdatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 4,
				"Section": "AssetClassification-View-DataAudit",
				"Group": "AssetClassification-View-DataAudit"
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "AssetClassification-View-Identity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "AssetClassification-View-Identity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Details",
			"Hash": "AssetClassification-View-Details",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Details",
					"Hash": "AssetClassification-View-Details",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Data Audit",
			"Hash": "AssetClassification-View-DataAudit",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Data Audit",
					"Hash": "AssetClassification-View-DataAudit",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}
